import { createFileRoute } from "@tanstack/react-router";
import AdminPartsCategoryEdit from "@/pages/admin/AdminPartsCategoryEdit";

export const Route = createFileRoute("/_adminLayout/admin/parts/categories/$basicCategory")({
  component: AdminPartsCategoryEdit,
});
